module.exports = __webpack_public_path__ + "media/images/area/area_mt-fujiM400-7c961313e69821251e8d070cfe73a551.jpg";